export const MANUAL_TRIGGER_BUTTON_PULSE_KEY = 'automation-manual-trigger-spotlight';
export const VERIFIED_CONTENT_PULSE_KEY = 'automation-verified-content-spotlight';
